let nightClinic = [
  {
    path: '/night_clinic',
    name: '夜间门诊',
    component: () => import('@/pages/nightClinic/index')
  }
]

export default nightClinic
